import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, useMediaQuery } from "@mui/material";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import SoftBox from "../../components/SoftBox";
import SoftButton from "../../components/SoftButton";
import UpgradePopUp from "../../components/ChallengeArenaPopUp/UpgradePopUp";
import SoftTypography from "../../components/SoftTypography";
import { UseCompanyColors } from "../../hooks/company";
import { DEFAULT_BRAND, brandRgba, brandDarken } from "../../helpers/brandColor";

const UnauthorizedPage = ({ forAdmin = true, upgradeRequired = false }) => {
  const [showUpgrade, setShowUpgrade] = useState(upgradeRequired);
  const navigate = useNavigate();
  const lgBreakpoint = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const { primaryColor: brandPrimary } = UseCompanyColors() || {};
  const brand = brandPrimary || DEFAULT_BRAND;

  const title = lgBreakpoint
    ? "You don't have permission to view this page"
    : "Not available on mobile";

  let subtitle = "Please switch to a desktop browser to view this page";
  if (lgBreakpoint) {
    subtitle = forAdmin ? "Only admin users can view this page" : "This page is restricted";
  }

  return (
    <>
      <SoftBox sx={{ height: { mini: "72px", md: "70px" } }} />
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <SoftBox
          bgColor="white"
          shadow="lg"
          borderRadius="xl"
          sx={{
            width: "100%",
            maxWidth: 380,
            textAlign: "center",
            p: { mini: 3, md: 4 },
          }}
        >
          <SoftBox
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              mx: "auto",
              mb: 2,
              background: `linear-gradient(180deg, ${brandRgba(brand, 0.16)}, ${brandRgba(brand, 0.06)})`,
            }}
          >
            <LockRoundedIcon sx={{ fontSize: 28, color: brand }} />
          </SoftBox>
          <SoftTypography variant="h6" fontWeight="bold" mb={0.5}>
            {title}
          </SoftTypography>
          <SoftTypography variant="button" color="text" fontWeight="regular" opacity={0.8}>
            {subtitle}
          </SoftTypography>
          {lgBreakpoint && (
            <SoftBox mt={3}>
              <SoftButton
                variant="gradient"
                color="info"
                size="small"
                onClick={() => navigate(-1)}
                sx={{
                  background: `${brand} !important`,
                  "&:hover": { background: `${brandDarken(brand)} !important` },
                }}
              >
                Go back
              </SoftButton>
            </SoftBox>
          )}
        </SoftBox>
      </Box>
      {upgradeRequired && (
        <UpgradePopUp
          showUpgrade={showUpgrade}
          closeUpgrade={() => {
            navigate(-1);
            setShowUpgrade(false);
          }}
        />
      )}
    </>
  );
};

export default UnauthorizedPage;
